import { Injectable, inject } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { filter, share } from 'rxjs/operators';
import { Tabs } from '@app/shared/tabs.enum';
import { isNil } from 'lodash-es';
import { isReportsApp } from '@app/reports-app/reports-app.util';

export enum Layouts {
  NO_LAYOUT,
  DEFAULT_LAYOUT,
}

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private router = inject(Router);

  public layout$: Subject<Layouts> = new ReplaySubject<Layouts>(1);
  public selectedTab$: Subject<Tabs> = new ReplaySubject<Tabs>();

  initialize() {
    this.subscribeToRouterEvents();
  }

  private subscribeToRouterEvents(): void {
    const routerEvents$ = this.router.events.pipe(share());

    const navigationEnd$ = routerEvents$.pipe(filter((event) => event instanceof NavigationEnd));
    navigationEnd$.subscribe((event) => {
      if (
        // The standalone reports app never renders the teacher/admin shell.
        isReportsApp() ||
        event.url === '/teacher.' ||
        event.url === '/admin.' ||
        event.url.startsWith('/component-library') ||
        event.url.startsWith('/logged-in') ||
        event.url.startsWith('/logout')
      ) {
        this.nextLayout(Layouts.NO_LAYOUT);
      } else {
        this.nextLayout(Layouts.DEFAULT_LAYOUT);
      }
    });

    const routeRecognized$ = routerEvents$.pipe(
      filter((event) => event instanceof RoutesRecognized),
    );

    routeRecognized$.subscribe((event: RoutesRecognized) => {
      const getAssociatedTab = (e: RoutesRecognized) => e.state.root.firstChild?.data?.['tab'];

      let selectedTab = getAssociatedTab(event);

      if (!isNil(selectedTab)) {
        this.selectedTab$.next(selectedTab);
      }
    });
  }

  private nextLayout(layout: Layouts) {
    this.layout$.next(layout);
  }
}
